import { useGetApiV1IndividualpaymentEditorsCoupons } from '@/shared/api/generated';
import { mapDropdownOptions, useDebouncedFilter } from '@/shared/ui/molecules/LookupAutocomplete';

/**
 * Busca de cupons por texto (debounce de 1 s + mínimo de 3 caracteres) para o
 * autocomplete do modal de aplicar cupom. Consome `individualpayment/editors/coupons`.
 *
 * É busca e não lista fechada porque o endpoint aceita `filter` — e o campo do
 * sistema legado é "Pesquisar Cupom", não um select de opções.
 *
 * @param filter - Texto digitado no campo (default `''`).
 * @returns `{ options, isLoading, isQuerySuccess }`.
 *
 * @example
 * ```tsx
 * const { options, isQuerySuccess } = useCouponSearchDropdown('volta');
 * ```
 */
export function useCouponSearchDropdown(filter = '') {
  const { debouncedFilter, isReady } = useDebouncedFilter(filter);

  const { data, isLoading, isSuccess } = useGetApiV1IndividualpaymentEditorsCoupons(
    isReady ? { filter: debouncedFilter } : undefined,
    { query: { enabled: isReady } },
  );

  return { options: mapDropdownOptions(data), isLoading, isQuerySuccess: isSuccess } as const;
}
